import { path } from 'ramda';
import axios, { AxiosError } from 'axios';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

import { HttpStatusCode } from 'enums/HttpStatusCode';

import { camelizeKeys } from './keysConverter';

export const getErrorStatusCode = (error: unknown): number => path(['response', 'status'], error);

export const isBadRequest = (error: unknown): boolean => {
  return getErrorStatusCode(error) === HttpStatusCode.badRequest;
};

export const isUnauthorizedError = (error: AxiosError): boolean =>
  getErrorStatusCode(error) === HttpStatusCode.unauthorized;

export const isAccessDenied = (error: unknown): boolean => {
  return getErrorStatusCode(error) === HttpStatusCode.forbidden;
};

export const isNotFoundError = (error: AxiosError): boolean => getErrorStatusCode(error) === HttpStatusCode.notFound;

export const isUnprocessedEntityError = (error: AxiosError): boolean =>
  getErrorStatusCode(error) === HttpStatusCode.unprocessedEntity;

export const isAxiosError = (error: unknown | AxiosError): error is AxiosError => axios.isAxiosError(error);

export const extractResponseErrors = (response: unknown): unknown => {
  return path(['response', 'data', 'errors'], response);
};

export const parseToFormikErrors = (errors: unknown): unknown => {
  const camelizedErrors = camelizeKeys(errors);
  return Object.keys(camelizedErrors).reduce((acc, key) => ({ ...acc, [key]: camelizedErrors[key].join(', ') }), {});
};

export const isRTKQueryError = (error: unknown): error is FetchBaseQueryError =>
  typeof error === 'object' && 'status' in error;

export const isRTKQueryUnprocessedEntityError = (error: FetchBaseQueryError): boolean =>
  error.status === HttpStatusCode.unprocessedEntity;

export const extractRTKQueryError = (error: FetchBaseQueryError): unknown => path(['data', 'errors'], error);
